import { FormEvent, useState } from 'react';

import { useTheme } from 'styled-components';

import { FormattedMessage, useIntl } from 'react-intl';

import { useModals } from 'context';

import { Modal } from 'components';

import { DischargeProps } from './types';

import * as S from './styles';

const Discharge: React.FC<DischargeProps> = ({ modalKey, isOpen, props }) => {
  const intl = useIntl();
  const { closeModal } = useModals();
  const theme = useTheme() as any; // eslint-disable-line

  const [dischargeReason, selectedDischargeReason] = useState<string>('');
  const [dischargeDescription, setDischargeDescription] = useState<string>('');

  return (
    <Modal
      isOpen={isOpen}
      data-testid="dischargeModal"
      closeModal={() => closeModal(modalKey)}
      overlayStyle={{ alignContent: 'center' }}
      contentStyle={{ paddingBottom: `${theme.yoga.spacing.medium}px` }}
    >
      <S.Container
        data-testid="dischargeContainer"
        onSubmit={(e: FormEvent) => {
          e.preventDefault();
          props.onSubmit({ dischargeReason, dischargeDescription });
        }}
      >
        <S.FormHeader>
          <S.Title data-testid="dischargeModalTitle">
            <FormattedMessage id="DISCHARGE.MODAL.TITLE" />
          </S.Title>
          <S.Alert>
            <S.AlertIcon data-testid="dischargeModalAlertIcon" />
            <S.AlertMessage data-testid="dischargeModalAlertMessage">
              <FormattedMessage id="DISCHARGE.MODAL.ALERT" />
            </S.AlertMessage>
          </S.Alert>
        </S.FormHeader>
        <S.DischargeBody>
          <S.Instruction data-testid="dischargeModalInstructionMessage">
            <FormattedMessage id="DISCHARGE.MODAL.INSTRUCTIONS" />
          </S.Instruction>
          <S.Radios
            name="discharging"
            selectedValue={dischargeReason}
            onChange={({
              target: { value },
            }: React.ChangeEvent<HTMLInputElement>) =>
              selectedDischargeReason(value)
            }
          >
            <S.RadioItem disabled>
              <S.Radio
                disabled // temporary disable https://gympass.atlassian.net/browse/LGATR-543
                value="discharge"
                data-testid="dischargeModalRadio1"
              />
              <S.RadioText data-testid="dischargeModalRadioLabel1">
                <FormattedMessage id="DISCHARGE.MODAL.RADIO.LABEL_1" />
              </S.RadioText>
            </S.RadioItem>
            <S.RadioItem>
              <S.Radio value="inactive" data-testid="dischargeModalRadio2" />
              <S.RadioText data-testid="dischargeModalRadioLabel2">
                <FormattedMessage id="DISCHARGE.MODAL.RADIO.LABEL_2" />
              </S.RadioText>
            </S.RadioItem>
          </S.Radios>
        </S.DischargeBody>
        <S.Description
          full
          data-testid="dischargeModalDescription"
          label={intl.formatMessage({
            id: 'DISCHARGE.MODAL.MESSAGE_LABEL',
          })}
          value={dischargeDescription}
          onChange={({
            target: { value },
          }: React.ChangeEvent<HTMLInputElement>) =>
            setDischargeDescription(value)
          }
        />
        <S.ButtonGroup>
          <S.CancelButton
            type="button"
            data-testid="dischargeModalCancelButton"
            onClick={() => closeModal(modalKey)}
          >
            <FormattedMessage id="DISCHARGE.MODAL.CANCEL" />
          </S.CancelButton>
          <S.SendButton
            disabled={!dischargeReason || !dischargeDescription}
            data-testid="dischargeModalSendButton"
          >
            <FormattedMessage id="DISCHARGE.MODAL.SEND" />
          </S.SendButton>
        </S.ButtonGroup>
      </S.Container>
    </Modal>
  );
};

export default Discharge;
